import { render } from "./PageSubmenu.vue?vue&type=template&id=31fe699e&scoped=true&ts=true"
import script from "./PageSubmenu.ts?vue&type=script&lang=ts"
export * from "./PageSubmenu.ts?vue&type=script&lang=ts"

import "./PageSubmenu.scss?vue&type=style&index=0&id=31fe699e&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31fe699e"]])

export default __exports__